import {
  titleUI,
  radioUI,
  radioSchema,
} from 'platform/forms-system/src/js/web-component-patterns';
import { childRelationshipLabels } from '../../../../utils/labels';
import { formatFullName } from '../../../../utils/helpers';

export default {
  uiSchema: {
    ...titleUI(({ formData }) => {
      const name = formatFullName(formData?.childFullName || {});
      return `${name || 'Child'}’s relationship to the Veteran`;
    }),
    relationship: radioUI({
      title: "What's the child's relationship to the Veteran?",
      labels: childRelationshipLabels,
    }),
  },
  schema: {
    type: 'object',
    properties: {
      relationship: radioSchema(Object.keys(childRelationshipLabels)),
    },
    required: ['relationship'],
  },
};
